import Hero from "../components/Hero";
import BookCar from "../components/BookCar";
import PickCar from "../components/PickCar";
import Banner from "../components/Banner";
import Footer from "../components/Footer";

function Home() {
  return (
    <>
      <Hero />
      <BookCar />
      <PickCar />
      <Banner />
      <Footer />
    </>
  );
}

export default Home;
